<template>
  <div>
    <section>
      <v-container container--fluid>
        <v-row class="px-4">
          <h1>Pick Pack Pricing</h1>
        </v-row>
        <v-row justify="space-between">
          <v-col cols="6" md="4">
            <v-text-field
              label="Search..."
              v-model="search"
              prepend-inner-icon="search"
            ></v-text-field>
          </v-col>
          <div style="display: flex; justify-content: center; align-items: center">
            <v-btn text @click="refresh" v-if="!isVisible">
              <v-icon color="cyan darken-2">refresh</v-icon>
            </v-btn>
            <div v-if="isVisible" class="load-3">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>
          <v-col cols="3" md="1" v-if="editPermission">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn fab dark color="blue lighten-1" @click="createNew" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new pick pack pricing</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedPickPackPrices"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers" :key="index">
              {{ props.item[header.value] }}
            </td>
            <td v-else style="text-align: center">
              <v-tooltip top color="secondary" v-if="editPermission">
                <template v-slot:activator="{ on }">
                  <v-icon color="blue" @click="editRow(props.item)" v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top color="secondary" v-if="editPermission">
                <template v-slot:activator="{ on }">
                  <v-icon color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
                    delete
                  </v-icon>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>

      <!-- Create/Edit Dialog -->
      <v-dialog
        v-model="pickPackDialog"
        max-width="600px"
      >
        <v-card>
          <v-card-title class="justify-center" style="position: relative">
            <h2>{{ editOrCreate }} Pick Pack Pricing</h2>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
            <v-container container--fluid grid-list-xl pb-0>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      label="Client name"
                      :items="clients"
                      item-text="name"
                      item-value="id"
                      v-model="client_id"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Pick Pack Price"
                      v-model="pick_pack_price"
                      :rules="[numberRules]"
                      type="number"
                      step="0.01"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      label="Depot (optional)"
                      :items="depots"
                      item-text="name"
                      item-value="id"
                      v-model="depot_id"
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center pb-5">
            <v-btn text @click="pickPackDialog = false" color="blue-grey lighten-2">Cancel</v-btn>
            <v-btn text @click="saveChanges" color="blue darken-1">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Confirmation Dialog -->
      <v-dialog
        v-model="deleteDialog"
        max-width="400px"
      >
        <v-card>
          <v-card-title class="justify-center">
            <h3>Delete Pick Pack Pricing</h3>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-center pt-4">
            Are you sure you want to delete this pick pack pricing?
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center pb-5">
            <v-btn text @click="deleteDialog = false" color="blue-grey lighten-2">Cancel</v-btn>
            <v-btn text @click="confirmDelete" color="red darken-1">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "PickPackPricing",
  components: {},
  data() {
    return {
      headers: [
        { text: 'Id', value: 'id', align: 'center', sortable: true },
        { text: 'Client Name', value: 'client_name', align: 'center', sortable: true },
        { text: 'Pick Pack Price', value: 'price', align: 'center', sortable: true },
        { text: 'Effective Date', value: 'effective_date', align: 'center', sortable: true },
        { text: 'Depot', value: 'depot_name', align: 'center', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      search: '',
      reload: false,
      isVisible: false,
      loading: false,
      deleteDialog: false,
      toBeDeleted: null,
      pickPackDialog: false,
      editOrCreate: null,
      editPickPack: null,
      // Form fields
      client_id: null,
      pick_pack_price: null,
      effective_date: null,
      depot_id: null,
    }
  },
  methods: {
    createNew() {
      this.editOrCreate = 'New';
      this.editPickPack = null;
      this.resetForm();
      this.pickPackDialog = true;
    },
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    },
    editRow(item) {
      this.editOrCreate = 'Edit';
      this.editPickPack = item;
      this.setFormValues(item);
      this.pickPackDialog = true;
    },
    deleteRow(item) {
      this.toBeDeleted = item;
      this.deleteDialog = true;
    },
    confirmDelete() {
      this.performDelete();
      this.deleteDialog = false;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    resetForm() {
      this.client_id = null;
      this.pick_pack_price = null;
      this.depot_id = null;
    },
    setFormValues(item) {
      this.client_id = item.client_id;
      this.pick_pack_price = item.price;
      this.depot_id = item.depot_id || null;
    },
    numberRules(val) {
      if (val === null || val === '') {
        return true;
      } else if (!/^(([0-9]+\.[0-9]*[0-9][0-9]*)|([0-9]*[0-9][0-9]*\.[0-9]+)|([0-9]*[0-9][0-9]*))$/.test(val)) {
        return 'Must be a number';
      } else {
        return true;
      }
    },
    saveChanges() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const body = {
        client_id: this.client_id,
        pricing_type: 'pick_pack',
        price: parseFloat(this.pick_pack_price),
        depot_id: this.depot_id,
      };

      if (this.editPickPack !== null) {
        this.updatePickPackPricing(this.editPickPack.id, body);
      } else {
        this.createPickPackPricing(body);
      }
    },
    performDelete() {
      if (this.toBeDeleted === null) return;

      axios.delete(process.env.API_URL + '/pickpackpricing/' + this.toBeDeleted.id)
        .then(() => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Delete successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'Delete failed: ' + error);
        });
      this.toBeDeleted = null;
    },
    updatePickPackPricing(id, body) {
      axios.post(process.env.API_URL + '/pickpackpricing/' + id, body)
        .then(() => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Update successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'Update failed: ' + error);
        });
      this.pickPackDialog = false;
    },
    createPickPackPricing(body) {
      axios.post(process.env.API_URL + '/pickpackpricing', body)
        .then(() => {
          this.updateDataTable();
          this.$store.commit('displaySnackbar', 'Create successful');
        })
        .catch((error) => {
          this.$store.commit('displaySnackbar', 'Create failed: ' + error);
        });
      this.pickPackDialog = false;
    },
  },
  computed: {
    editPermission() {
      return this.$store.getters['auth/hasPermission']('client_pricing_edit');
    },
    renderedPickPackPrices() {
      if (this.pickPackPrices === null || this.pickPackPrices === undefined) {
        return [];
      } else {
        const depotMap = {};
        if (this.depots && Array.isArray(this.depots)) {
          this.depots.forEach(d => { depotMap[d.id] = d.name; });
        }
        return this.pickPackPrices.map(item => ({
          ...item,
          depot_name: item.depot_id ? (depotMap[item.depot_id] || item.depot_name || '') : (item.depot_name || ''),
        }));
      }
    },
  },
  asyncComputed: {
    async pickPackPrices() {
      if (this.reload || !this.reload) {
        return await axios.get(process.env.API_URL + '/pickpackpricing')
          .then((response) => {
            return response.data;
          })
          .catch(() => {
            return [];
          });
      }
    },
    async clients() {
      return await axios.get(process.env.API_URL + '/clients')
        .then((response) => {
          return Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
        })
        .catch(() => {
          return [];
        });
    },
    async depots() {
      return await axios.get(process.env.API_URL + '/depots')
        .then((response) => {
          return response.data.sort((a, b) => (a.name > b.name) ? 1 : -1);
        })
        .catch(() => {
          return [];
        });
    }
  }
}
</script>

<style scoped>
>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none !important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}

.load-3 .line:nth-last-child(1) {
  animation: loadingC .6s .1s linear infinite;
}

.load-3 .line:nth-last-child(2) {
  animation: loadingC .6s .2s linear infinite;
}

.load-3 .line:nth-last-child(3) {
  animation: loadingC .6s .3s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Manage/PickPackPricing.vue